export function parseStringifiedValue(value) {
    try {
        return JSON.parse(value);
    }
    catch (error) {
        return value;
    }
}
//# sourceMappingURL=utils.js.map